import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, MoreVertical, Radio } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../components/ui/DropdownMenu';
import { podcastCollections } from '../../src/seed';
export function PodcastCollections() {
  const navigate = useNavigate();
  const getRelativeSyncTime = (id: string) => {
    if (id === 'pc1') return 'Synced 2 hours ago';
    if (id === 'pc2') return 'Synced 8 hours ago';
    return 'Synced recently';
  };
  return <div className="space-y-6" data-id="element-404">
      <div className="flex items-center justify-between" data-id="element-405">
        <div data-id="element-406">
          <h1 className="text-3xl font-bold tracking-tight" data-id="element-407">Collections</h1>
          <p className="text-muted-foreground" data-id="element-408">
            Podcast shows and curated episode groups
          </p>
        </div>
        <Button onClick={() => navigate('/podcast/collections/new')} data-id="element-409">
          <Plus className="mr-2 h-4 w-4" data-id="element-410" />
          New collection
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-411">
        {podcastCollections.map(collection => <Card key={collection.id} className="cursor-pointer hover:shadow-md transition-shadow group relative" onClick={() => console.log('Navigate to collection', collection.id)} data-id="element-412">
            <CardHeader className="pb-3" data-id="element-413">
              <div className="flex items-start justify-between" data-id="element-414">
                <div data-id="element-415">
                  <CardTitle className="text-lg" data-id="element-416">{collection.name}</CardTitle>
                  <div className="flex items-center gap-2 mt-1.5" data-id="element-417">
                    {collection.source === 'rss' ? <Badge variant="default" className="flex items-center gap-1" data-id="element-418">
                        <Radio className="h-3 w-3" data-id="element-419" />
                        RSS · auto-sync
                      </Badge> : <Badge variant="secondary" data-id="element-420">Manual</Badge>}
                    <CardDescription className="m-0" data-id="element-421">
                      {collection.itemCount} episodes
                    </CardDescription>
                  </div>
                  {collection.source === 'rss' && <p className="text-xs text-muted-foreground mt-1.5" data-id="element-422">
                      {getRelativeSyncTime(collection.id)}
                    </p>}
                </div>
                <DropdownMenu data-id="element-423">
                  <DropdownMenuTrigger asChild onClick={e => e.stopPropagation()} data-id="element-424">
                    <Button variant="ghost" size="icon" className="h-8 w-8 -mr-2 -mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-425">
                      <MoreVertical className="h-4 w-4" data-id="element-426" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" data-id="element-427">
                    <DropdownMenuItem onClick={e => e.stopPropagation()} data-id="element-428">
                      Edit
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={e => e.stopPropagation()} className="text-destructive" data-id="element-429">
                      Delete
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </CardHeader>
            <CardContent data-id="element-430">
              <p className="text-sm text-muted-foreground mb-4 line-clamp-2 h-10" data-id="element-431">
                {collection.description}
              </p>
              <div className="flex gap-2" data-id="element-432">
                <div className="size-12 rounded-md bg-muted" data-id="element-433" />
                <div className="size-12 rounded-md bg-muted" data-id="element-434" />
                <div className="size-12 rounded-md bg-muted" data-id="element-435" />
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}